import { useMemo } from 'react';
import { IStateValidation } from './useStateValidation';

export function useValidationResultMemo({
	isValid,
	redirectUrl,
}: IStateValidation) {
	return useMemo(
		() => ({
			isValid,
			redirectUrl,
		}),
		[isValid, redirectUrl],
	);
}
